import en_US from '@/locales/en_US';
import en_GB from '@/locales/en_GB';
import fi_FI from '@/locales/fi_FI';
import fr_CA from '@/locales/fr_CA';
import fr_FR from '@/locales/fr_FR';
import nb_NO from '@/locales/nb_NO';
import es_ES from '@/locales/es_ES';
import it_IT from '@/locales/it_IT';
import da_DK from '@/locales/da_DK';

export const langs = ['en_US', 'en_GB', 'fi_FI', 'fr_CA', 'fr_FR', 'nb_NO', 'es_ES', 'it_IT', 'da_DK'];
export const messages = {
    en_US,
    en_GB,
    fi_FI,
    fr_CA,
    fr_FR,
    nb_NO,
    es_ES,
    it_IT,
    da_DK,
  };